<script lang="ts">
  import { api } from "../lib/api";
  import type { PodStatus } from "@antares/shared";

  interface Props {
    ns: string;
    name: string;
    status: PodStatus;
    onAction?: () => void;
  }

  let { ns, name, status, onAction }: Props = $props();
  let acting = $state(false);
  let message = $state("");

  async function restartPod() {
    if (!confirm(`Restart pod ${name}? You'll be redirected to the dashboard to pick up the replacement pod.`)) return;
    acting = true;
    message = "";
    try {
      await api.deletePod(ns, name);
      message = "Pod deleted, returning to dashboard...";
      // Short delay so the user sees the message, then redirect
      setTimeout(() => {
        window.location.hash = "/";
      }, 1500);
    } catch (err: any) {
      message = `Failed: ${err.message}`;
      acting = false;
    }
  }

  async function stopPod() {
    if (!confirm(`Stop pod ${name}? This scales the deployment to 0 replicas.`)) return;
    acting = true;
    message = "";
    try {
      await api.scalePod(ns, name, 0);
      message = "Scaled to 0, returning to dashboard...";
      setTimeout(() => {
        window.location.hash = "/";
      }, 1500);
    } catch (err: any) {
      message = `Failed: ${err.message}`;
      acting = false;
    }
  }

  async function startPod() {
    acting = true;
    message = "";
    try {
      await api.scalePod(ns, name, 1);
      message = "Scaled to 1";
      onAction?.();
    } catch (err: any) {
      message = `Failed: ${err.message}`;
    } finally {
      acting = false;
    }
  }
</script>

<div class="controls">
  <button class="btn" onclick={restartPod} disabled={acting}>
    Restart
  </button>
  <button class="btn btn-danger" onclick={stopPod} disabled={acting}>
    Stop
  </button>
  <button class="btn btn-success" onclick={startPod} disabled={acting}>
    Start
  </button>
  {#if message}
    <span class="message">{message}</span>
  {/if}
</div>

<style>
  .controls {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .btn {
    padding: 0.35rem 0.75rem;
    border: 1px solid var(--border);
    border-radius: 4px;
    background: var(--bg-elevated);
    color: var(--text);
    font-size: 0.8rem;
    cursor: pointer;
  }

  .btn:hover:not(:disabled) { border-color: var(--text-muted); }
  .btn:disabled { opacity: 0.5; cursor: not-allowed; }
  .btn-danger { color: var(--danger); border-color: var(--danger); }
  .btn-danger:hover:not(:disabled) { background: rgba(248, 113, 113, 0.1); }
  .btn-success { color: var(--success); border-color: var(--success); }
  .btn-success:hover:not(:disabled) { background: rgba(74, 222, 128, 0.1); }

  .message {
    font-size: 0.75rem;
    color: var(--text-muted);
    margin-left: 0.25rem;
  }
</style>
